import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

@Component({
  selector: 'app-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrls: ['./custom-tooltip.component.scss'],
  standalone: false 
})
export class CustomTooltipComponent implements ITooltipAngularComp {
  public params: any;

  agInit(params: ITooltipParams<any, any>): void {
    this.params = params;
  }
}
